define(function (require) {
	"use strict";

	var LE = require("app");
	var CONST = require("const");
	var Page = require("ui.components/page/Page");
	var ErrorCodes = require("codeTables/errorCodes.json");

	var LobModel = require("models/entities/LobModel");
	var LobEditView = require("user-management-views/lobs/LobEditView");
	var LobsFooterView = require("user-management-views/lobs/LobsFooterView");

	var LobEditController = {};

	function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
		LobEditController = Marionette.Controller.extend({
			pageView: null,
			insideView: null,
			LobModel: null,
			initialize: function(options) {
				this._initialize(options);
			},

			getView: function() {
				return this.pageView;
			},
			showLobEdit: function(lobId) {
				this._showLobEdit(lobId);
			},

			_initialize: function() {
				LEUserManagement.logger.info("initializing", "LobEditController:initialize");
				this.channel = LEUserManagement.media.channel(LEUserManagement.channels.LOB_EDIT);
				this._initPageView();
				this._bindEvents();
			},

			_initPageView: function(){
				LEUserManagement.logger.debug("init page view and listen to its close", "LobEditController:_initPageView");
				this.pageView = new Page({
					moduleName: LEUserManagement.moduleName,
					context: LE.context,
					permutation: Page.PERMUTATION.Standard,
					contentWidth: Page.CONTENT_WIDTH.Large,
					footer: new LobsFooterView()
				});
				this.listenTo(this.pageView, "close", this._onPageClose);
			},

			_bindEvents: function() {
				this.listenTo(this.channel.vent, "lob:change:name", this._onNameChange);
				this.listenTo(this.channel.vent, "lob:change:description", this._onDescriptionChange);
				this.listenTo(this.channel.vent, "lob:cancel", this._onCancel);
				this.listenTo(this.channel.vent, "lob:save", this._onSave);
			},

			_showLobEdit: function(lobId) {
				LEUserManagement.logger.info("show lob edit view", "LobEditController:_showLobEdit", lobId);
				if (lobId === CONST.ROUTING.NEW_ITEM_ID) {
					this._closeLayoutLoader();
					this._createNewLob();
				}
				else {
					this._fetchLob(lobId);
				}
			},

			_createNewLob: function() {
				this.lobModel = new LobModel();
				this._showView();
			},
			_fetchLob: function(lobId) {
				this.lobModel = new LobModel({id:lobId});
                this._showLayoutLoader();
				this.lobModel.fetch({
					success: _.bind(this._onFetchLobSuccess, this),
					error:  _.bind(this._onFetchLobError, this)
				});
			},

			_onFetchLobSuccess: function(model, response) {
				LEUserManagement.logger.debug("fetch lob success", "LobEditController:_onFetchLobSuccess", response);
				this._closeLayoutLoader();
				this._showView();
			},
			_onFetchLobError: function(model, response) {
				LEUserManagement.logger.debug("fetch lob error closing loader returning to list", "LobEditController:_onFetchLobError", response);
				this._closeLayoutLoader();
				LEUserManagement.notifier.showError({content:LE.translator.translate("LEUserManagement.lobEdit.errorOnFetching.text"), timeToShow: 6000});
				this._navigateToLobList();
			},

			_showView: function() {
				LEUserManagement.logger.debug("show the lob edit view in the page", "LobEditController:_showView");
				var title = (this.lobModel.isNew()) ? LE.translator.translate("LEUserManagement.lobEdit.header.title.new") : LE.translator.translate("LEUserManagement.lobEdit.header.title.edit");
				this.insideView = new LobEditView({model: this.lobModel});
				this.pageView.setTitle(title);
				this.pageView.setDescription(LE.translator.translate("LEUserManagement.lobEdit.header.description"));
				this.pageView.setInsideView(this.insideView);
			},

			_onNameChange: function(name) {
				this.lobModel.setName(name);
			},

			_onDescriptionChange: function(description) {
				this.lobModel.setDescription(description);
			},

			_onCancel: function() {
				LEUserManagement.logger.info("cancel the lob edit", "LobEditController:_onCancel");

				this._navigateToLobList();
			},

			_onSave: function() {
				LEUserManagement.logger.info("save the lob", "LobEditController:_onSave", this.lobModel);
				this._beforeSave();
				this.lobModel.save(null, {
					ignoreError: true,
					success: _.bind(this._onSaveSuccess, this),
					error: _.bind(this._onSaveError, this)
				});
			},

			_onSaveSuccess: function(model) {
				LEUserManagement.logger.info("lob saved successfully", "LobEditController:_onSaveSuccess", model);
                LEUserManagement.getDataManager().updateCollection(model, {exclusively:false}); // because we have 2 collections of lob (LobsCollection & LobRelationsCollection) we need to update the model in both, and not only in first we find
				this._afterSave();
				this._navigateToLobList();
			},

			_onSaveError: function(model, resp, options) {
				LEUserManagement.logger.info("lob could not be saved", "LobEditController:_onSaveError", model);
				this._afterSave();
				var errorObject = {};
				var generalErrorMessage = {};

				if (resp && resp.responseError && resp.responseError.internalCode) {
					if (resp.responseError.internalCode === ErrorCodes.uniquenessViolation) {
						errorObject[model.KEYS.NAME] = "LEFramework.entities.lob.errors.name.duplicated";
					} else if (resp.responseError.internalCode === ErrorCodes.concurrentModificationConflict) {
						generalErrorMessage.errorMessage = "LEFramework.entities.lob.errors.outdated.revision.error";
					}  else if (resp.responseError.internalCode === ErrorCodes.maxEntityLimitViolation) {
                        generalErrorMessage.errorMessage = "LEUserManagement.lobList.error.maximum.items";
                    } else if (resp.responseError.internalCode === ErrorCodes.noDataFound) {
                        generalErrorMessage.errorMessage = "LEFramework.entities.lob.errors.entity.was.deleted";
                        this._onCancel();
                    }
                }
				this._showErrorMessageAfterSave(model, errorObject, generalErrorMessage);
			},

			_showErrorMessageAfterSave: function(model, errorObject, options) {
				var errorMessageKey;
				if(options && options.errorMessage) {
					errorMessageKey = options.errorMessage;
				} else {
					errorMessageKey = "LEUserManagement.lobEdit.errors.general.error";
				}
				var defaultMessage = LE.translator.translate(errorMessageKey);
				var messageToShow;
				var translatedErrorObj = {};

				if (!_.isEmpty(errorObject)) {
					_.each(errorObject, function (value, key, obj) {
						translatedErrorObj[key] = LE.translator.translate(value);
					});
					messageToShow = LEUserManagement.getGeneralErrorMsg(translatedErrorObj);
				} else {
					messageToShow = defaultMessage;
				}
				LEUserManagement.notifier.showError({"content":messageToShow,"timeToShow":8000});
				this.channel.trigger("lob:save:error", translatedErrorObj);
			},

			_onSaveInvalid: function(model, errorObject) {
				LEUserManagement.logger.info("lob could not be saved", "LobEditController:_onSaveInvalid", model);

				this._afterSave();

				var translatedErrorObj = {};
				_.each(errorObject, function (value, key) {
					translatedErrorObj[key] = LE.translator.translate(value);
				});

				LEUserManagement.notifier.showError(LEUserManagement.getGeneralErrorMsg(translatedErrorObj));
				this.channel.trigger("lob:save:error", translatedErrorObj);
			},

			_beforeSave: function() {
				this._showLoader();
				this.listenTo(this.lobModel, "invalid", this._onSaveInvalid);
			},

			_afterSave: function() {
				this.stopListening(this.lobModel, "invalid");
				this._closeLoader();
			},

			_showLoader: function() {
				this.pageView.showLoader();
			},

			_closeLoader: function() {
				this.pageView.closeLoader();
			},

            _showLayoutLoader: function() {
                LEUserManagement.showLoader();
            },

			_closeLayoutLoader: function() {
				LEUserManagement.closeLoader();
			},

			_navigateToLobList: function() {
				LEUserManagement.logger.info("navigate to lob list", "LobEditController:_navigateToLobList");
				LEUserManagement.router.navigate("lobs");
			},

			_onPageClose: function() {
				LEUserManagement.logger.debug("Page component in lob edit is closed. re-init it.", "LobEditController:onPageClose");
				this.insideView = null;
				this.stopListening(this.pageView);
				this._initPageView();
			}

		});
	}

	LE.module("LEUserManagement", moduleDefinition);

	return  LobEditController;
});
